import React, { useEffect, useState } from 'react';
import { fetchLibraryArtworkBlobUrl } from '../../api/libraryAdminApi';
type Props = { itemKey: string; assetKey: string | null; checksum: string | null; signedUrl: string | null; title: string; onReload: () => Promise<void>; onReady: (ready: boolean) => void; };
export default function EditorialArtwork({ itemKey, assetKey, checksum, signedUrl, title, onReload, onReady }: Props) {
  const [src, setSrc] = useState<string | null>(null);
  const [status, setStatus] = useState<'loading' | 'ready' | 'error'>('loading');
  const [attempt, setAttempt] = useState(0);
  useEffect(() => {
    let cancelled = false;
    let objectUrl: string | null = null;
    setSrc(null); setStatus('loading'); onReady(false);
    if (!assetKey) return;
    // Display signed images directly, without a cross-origin fetch redirect.
    if (signedUrl) setSrc(signedUrl);
    else void fetchLibraryArtworkBlobUrl(itemKey).then(url => {
      if (cancelled) { if (url) URL.revokeObjectURL(url); return; }
      objectUrl = url;
      if (url) setSrc(url); else setStatus('error');
    }).catch(() => { if (!cancelled) setStatus('error'); });
    return () => { cancelled = true; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [itemKey, assetKey, checksum, signedUrl, attempt, onReady]);
  useEffect(() => {
    if (!assetKey || status !== 'loading') return;
    const timer = window.setTimeout(() => setStatus('error'), 20000);
    return () => window.clearTimeout(timer);
  }, [assetKey, status, attempt]);
  if (!assetKey) return <div className="classics-editor__art-placeholder">No artwork uploaded</div>;
  return <div>
    {status === 'loading' && <p role="status">Loading artwork…</p>}
    {src && <img key={src + attempt} className="classics-editor__artwork" src={src} alt={`Editorial artwork for ${title}`} referrerPolicy="no-referrer"
      style={status === 'ready' ? undefined : { display: 'none' }}
      onLoad={() => { setStatus('ready'); onReady(true); }} onError={() => { setStatus('error'); onReady(false); }} />}
    {status === 'error' && <div role="alert"><p>The artwork is saved, but the image could not load. Retry to request a fresh image link.</p>
      <button className="secondary" onClick={async () => { setStatus('loading'); onReady(false); try { await onReload(); } catch { /* The page reports reload errors. */ } finally { setAttempt(n => n + 1); } }}>Retry artwork</button>
    </div>}
  </div>;
}
